module.exports = __webpack_public_path__ + "fb493903265cad425ccdf8e04fc2de61.woff2";